
<template>
  <!-- <div :style="{padding: getPadding(data?.style?.padding), textAlign: data?.style?.textAlign || 'left', position: data?.style?.position || 'static'}"> -->
  <div :style="getStyle(data?.style)">
    <img
      :src="data?.props?.url || ''"
      :alt="data?.props?.alt || ''"
      :style="getImgStyle(data)"
    />
  </div>
</template>

<script>
export default {
  name: 'ImageBlock',
  props: {
    data: Object,
  },
  methods: {
    getStyle(style){
      const backgroundColor = style?.backgroundColor || null;
      if(style?.position) {
        const position = style.position 
        const left = `${style.direction.left}px`;
        const top = `${style.direction.top}px`;
        const textAlign = style?.textAlign || 'left'
        return {
          textAlign: textAlign,
          backgroundColor: backgroundColor, 
          position: position,
          left: left,
          top: top,
          padding: `${style.padding.top}px ${style.padding.right}px ${style.padding.bottom}px ${style.padding.left}px`,
        }
    } else {
      const textAlign = style?.textAlign || 'left'
      return { 
        textAlign: textAlign,
        backgroundColor:  backgroundColor, 
        padding: `${style.padding.top}px ${style.padding.right}px ${style.padding.bottom}px ${style.padding.left}px` }
    }
    },
    getImgStyle(data){
      if (data.style?.borderColor && data.style?.borderColor != null) {
        const border = `${data.style?.borderColor} 1px solid` || null;
        console.log(border)
        return {
        border: border,
        outline: 'none',
        textDecoration: 'none',
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
        width: data?.props?.width ? `${data.props.width}px` : 'auto',
        height: data?.props?.height ? `${data.props.height}px` : 'auto'
      }
      } else {
        return {
        outline: 'none',
        border: 'none',
        textDecoration: 'none',
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
        width: data?.props?.width ? `${data.props.width}px` : 'auto',
        height: data?.props?.height ? `${data.props.height}px` : 'auto'
      }
      }
    }
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>




